import { BrandColors } from "../theme";

export const iconFieldTokens = {
    icon: {
        color : BrandColors.semantic.text,
    }

}